
export enum PointsExpire {
    Never = 'Never',
    EveryMonth = 'EveryMonth',
    EveryWeek = 'EveryWeek',
    Yearly = 'Yearly'
}
